import api from "@/services/api"
import { ref } from "vue"
import { useNotification } from "@/composables"
import {defineStore} from "pinia"

export const useCountriesStore = defineStore('countries', () => {
    const { showError } = useNotification()

    const apiCountries = ref([])
    const setApiCountries = (value) => {
        apiCountries.value = value
    }

    const fetchingCountries = ref(false)
    const setFetchingCountries = (value) => {
        fetchingCountries.value = value
    }

    const fetchCountries = async () => {
        try {
            setFetchingCountries(true)
            const response = await api.get('/countries')
            setApiCountries(response.data.data)
        } catch (error) {
            console.error(error)
            showError("Failed to fetch countries")
        } finally {
            setFetchingCountries(false)
        }
    }

    return {
        apiCountries,
        fetchCountries,
        fetchingCountries
    }
})